import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import ProgressBar from './shared/components/presentation/progress-bar/ProgressBar';
import { Grid, GridItem } from './shared/components/presentation/grid/Grid';
import { determineProgress, determineIcon } from './webappointment/functions/progressSupportFunctions';
import defaultIcon from './webappointment/imgs/default.svg';
import WhatToExpectPage from './webappointment/components/what-to-expect-page/WhatToExpectPage';
import WhoForPage from './webappointment/components/who-for-page/WhoForPage';
import ReceivedCarePage from './webappointment/components/received-care-page/ReceivedCarePage';
import ContactInfoPage from './webappointment/components/contact-info-page/ContactInfoPage';
import NewPatientInfoPage from './webappointment/components/new-patient-info-page/NewPatientInfoPage';
import NewPatientAddressPhonePage from './webappointment/components/new-patient-address-phone-page/NewPatientAddressPhonePage';
import ExistingPatientInfoPage from './webappointment/components/existing-patient-info-page/ExistingPatientInfoPage';

import AppointmentInfo1Page from './webappointment/components/appointment-info1-page/AppointmentInfo1Page';
import AppointmentInfo2Page from './webappointment/components/appointment-info2-page/AppointmentInfo2Page';
import AppointmentPreferencesPage from './webappointment/components/appointment-preferences-page/AppointmentPreferencesPage';
import AppointmentProviderPage from './webappointment/components/appointment-provider-page/AppointmentProviderPage';
import AppointmentDayTimePage from './webappointment/components/appointment-day-time-page/AppointmentDayTimePage';

import PaymentMethodPage from './webappointment/components/payment-method-page/PaymentMethodPage';
import InsurancePage from './webappointment/components/insurance-page/InsurancePage';
import BillingPage from './webappointment/components/billing-page/BillingPage';
import BillingAddressPage from './webappointment/components/billing-address-page/BillingAddressPage';
import PolicyHolderPage from './webappointment/components/policy-holder-page/PolicyHolderPage';

import OutOfPocketPage from './webappointment/components/out-of-pocket-page/OutOfPocketPage';
import ReviewPage from './webappointment/components/review-page/ReviewPage';
import PfaAppointmentPage from './webappointment/components/pfa-appointment-page/PfaAppointmentPage';

import ThankYouPfaAppointmentPage from './webappointment/components/thank-you-pfa-appointment-page/ThankYouPfaAppointmentPage';
import ThankYouPfaPage from './webappointment/components/thank-you-pfa-page/ThankYouPfaPage';
import ThankYouInsurancePage from './webappointment/components/thank-you-insurance-page/ThankYouInsurancePage';
import ErrorReviewPage from './webappointment/components/error-review-page/ErrorReviewPage';

import './App.css';


import * as routes from './constants/routes';

export class App extends Component {
  constructor(props) {
    super(props);
    this.progressBar = React.createRef();
    this.prevPage = "";
  }

  componentDidMount() {
    this.setProgressBarOnUrl();
  }

  componentDidUpdate() {
    this.setProgressBarOnUrl();
  }

  setProgressBarOnUrl = () => {
    if (this.progressBar && this.progressBar.current) {
      let urlPath = window.location.pathname.split("/").pop();

      if (urlPath) {
        this.setProgressBarStep(determineProgress(urlPath));
      }
    }
  }

  setProgressBarStep = (stepNumber) => {
    if (this.progressBar && this.progressBar.current) {
      this.progressBar.current.setStepNumber(stepNumber);
    }
  }

  render() {
    // Scroll to the top of the form page iff changing pages.  i.e. Don't
    // scroll if rerendering the same page.
    if (this.prevPage !== window.location.pathname) {
      let root = document.getElementById("root");
      if (root) {
        // Use a setTimeout to scroll to work around the browsers built-in
        // scroll-to-previous-position, when going back a page.
        setTimeout(() => {
          root.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest"
        });}, 1);
      }
    }
    this.prevPage = window.location.pathname;
    return (
      <div className="container content-pad web-appt">
        <div className="web-appt__sticky-wrapper">
          <Grid>
            <GridItem>
              <ProgressBar
                defaultIcon={{
                  altText: "A light gray circle with a darker gray silhouette.",
                  path: defaultIcon
                }}
                icon={determineIcon(window.location.pathname.split("/").pop(), this.props.webAppointmentFormState)}
                ref={this.progressBar}
                totalSteps={20}
              />
            </GridItem>
          </Grid>
        </div>
        <Switch>
        <Route path={routes.WEB_APPOINTMENT_ROOT} exact>
            <Redirect to={routes.WEB_APPOINTMENT_WHAT_TO_EXPECT_PAGE} />
          </Route>
          <Route path={routes.WEB_APPOINTMENT_ROOT_SLASH} exact>
            <Redirect to={routes.WEB_APPOINTMENT_WHAT_TO_EXPECT_PAGE} />
          </Route>
          <Route path={routes.WEB_APPOINTMENT_WHAT_TO_EXPECT_PAGE} component={WhatToExpectPage} />
          <Route path={routes.WEB_APPOINTMENT_WHO_FOR_PAGE} component={WhoForPage} />
          <Route path={routes.WEB_APPOINTMENT_RECEIVED_CARE_PAGE} component={ReceivedCarePage} />

          <Route path={routes.WEB_APPOINTMENT_CONTACT_INFO_PAGE} component={ContactInfoPage} />

          <Route path={routes.WEB_APPOINTMENT_NEW_PATIENT_INFO_PAGE} component={NewPatientInfoPage} />
          <Route path={routes.WEB_APPOINTMENT_NEW_PATIENT_ADDRESS_PAGE} component={NewPatientAddressPhonePage} />
          <Route path={routes.WEB_APPOINTMENT_EXISTING_PATIENT_INFO_PAGE} component={ExistingPatientInfoPage} />

          <Route path={routes.WEB_APPOINTMENT_APPOINTMENT_INFO1_PAGE} component={AppointmentInfo1Page} />
          <Route path={routes.WEB_APPOINTMENT_APPOINTMENT_INFO2_PAGE} component={AppointmentInfo2Page} />
          <Route path={routes.WEB_APPOINTMENT_APPOINTMENT_PREFERENCES_PAGE} component={AppointmentPreferencesPage} />
          <Route path={routes.WEB_APPOINTMENT_APPOINTMENT_INFO_PROVIDER} component={AppointmentProviderPage} />
          <Route path={routes.WEB_APPOINTMENT_APPOINTMENT_INFO_DAY_TIME} component={AppointmentDayTimePage} />

          <Route path={routes.WEB_APPOINTMENT_PAYMENT_METHOD} component={PaymentMethodPage} />
          <Route path={routes.WEB_APPOINTMENT_INSURANCE} component={InsurancePage} />
          <Route path={routes.WEB_APPOINTMENT_BILLING} component={BillingPage} />
          <Route path={routes.WEB_APPOINTMENT_BILLING_ADDRESS} component={BillingAddressPage} />
          <Route path={routes.WEB_APPOINTMENT_POLICY_HOLDER} component={PolicyHolderPage} />
          <Route path={routes.WEB_APPOINTMENT_OUT_OF_POCKET} component={OutOfPocketPage} />
          <Route path={routes.WEB_APPOINTMENT_REVIEW} component={ReviewPage} />
          <Route path={routes.WEB_APPOINTMENT_ERROR_REVIEW} component={ErrorReviewPage} />
          <Route path={routes.WEB_APPOINTMENT_PFA_APPOINTMENT} component={PfaAppointmentPage} />
          <Route path={routes.WEB_APPOINTMENT_THANK_YOU_PFA_APPT} component={ThankYouPfaAppointmentPage} />
          <Route path={routes.WEB_APPOINTMENT_THANK_YOU_PFA} component={ThankYouPfaPage} />
          <Route path={routes.WEB_APPOINTMENT_THANK_YOU_INSURANCE} component={ThankYouInsurancePage} />
        </Switch>
      </div>
    );
  }
}
// allows component to access user property from redux state
function mapStateToProps(state, ownProps) {
  return {
    webAppointmentFormState: state.webAppointmentForm
  };
}

// connects component to redux
export default withRouter(connect(mapStateToProps)(App));
